import logo from './logo.svg';
// import './App.css';
import NewApplication from './Component/NewApplication/NewApplication';


function App() {
  return (
    <div className="App">
    <NewApplication/>
    </div>
  );
}

export default App;
